import { Utils } from '@everyboard/lib';
import { PlayerOrNone } from '../../jscaip/Player';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
/**
 * Represent half a tile
 * owner: to make us know which half of a tile it is (since trexo tiles are bicolor)
 * tileId: we need this info to enforce the "don't play on only one tile" rules
 *     it is filled with the turn at which the tile is dropped
 */
export class TrexoPiece {
    owner;
    tileId;
    constructor(owner, tileId) {
        this.owner = owner;
        this.tileId = tileId;
    }
    toString() {
        return `TrexoPiece(${this.owner.toString()}, ${this.tileId})`;
    }
}
export class TrexoPieceStack {
    pieces;
    static EMPTY = TrexoPieceStack.of([]);
    static of(pieces) {
        let previousTurn = -1;
        for (const piece of pieces) {
            Utils.assert(previousTurn < piece.tileId, 'TrexoPieceStack: dropped turn should be ascending');
            previousTurn = piece.tileId;
        }
        return new TrexoPieceStack(pieces);
    }
    constructor(pieces) {
        this.pieces = pieces;
    }
    getHeight() {
        return this.pieces.length;
    }
    getOwner() {
        const numberOfPiece = this.pieces.length;
        if (numberOfPiece === 0) {
            return PlayerOrNone.NONE;
        }
        else {
            const lastPiece = this.pieces[numberOfPiece - 1];
            return lastPiece.owner;
        }
    }
    getUpperTileId() {
        const numberOfPiece = this.pieces.length;
        if (numberOfPiece === 0) {
            return -1;
        }
        else {
            const lastPiece = this.pieces[numberOfPiece - 1];
            return lastPiece.tileId;
        }
    }
    add(piece) {
        return TrexoPieceStack.of(this.pieces.concat(piece));
    }
    getPieceAt(z) {
        Utils.assert(z < this.pieces.length, 'no element ' + z + 'in piece!');
        return this.pieces[z];
    }
    isGround() {
        return this.getUpperTileId() === -1;
    }
    toString() {
        return '[' + this.pieces.map((piece) => {
            return '(' + piece.toString() + ')';
        }).join(' ') + ']';
    }
}
export class TrexoState extends GameStateWithTable {
    static SIZE = 10;
    static isOnBoard(coord) {
        return coord.isInRange(TrexoState.SIZE, TrexoState.SIZE);
    }
    static of(board, turn) {
        Utils.assert(board.length === TrexoState.SIZE, 'Invalid board dimensions');
        for (const lines of board) {
            Utils.assert(lines.length === TrexoState.SIZE, 'Invalid board dimensions');
        }
        return new TrexoState(board, turn);
    }
    drop(coord, player) {
        const newBoard = this.getCopiedBoard();
        const droppedPiece = new TrexoPiece(player, this.turn);
        newBoard[coord.y][coord.x] = newBoard[coord.y][coord.x].add(droppedPiece);
        return new TrexoState(newBoard, this.turn);
    }
    incrementTurn() {
        return new TrexoState(this.getCopiedBoard(), this.turn + 1);
    }
    toString() {
        return this.board.map((list) => {
            return '[' + list.map((space) => {
                return 'TrexoPieceStack.of(' + space.toString() + ')';
            }).join(', ') + ']';
        }).join('\n,');
    }
    getPieceAtXYZ(x, y, z) {
        const stack = this.getPieceAtXY(x, y);
        return stack.getPieceAt(z);
    }
}
